import km from 'keymirror'
import version from './version'
import wx from 'weixin-js-sdk'
import cookie from '../lib/cookie'
import CONSTANT from '../constant/cookie'
const VALUE = km({
  MZMall: null,
  WECHAT: null,
  MZMall_STANDARD: null,
  WEB: null,
  ANDROID: null,
  IOS: null,
})


const getUa = () => {
  return window.navigator.userAgent
}
export const app = {
  isAliApp:() => {
    return /AliApp/.test(getUa());
  },
  isWechat: () => {
    // 微信环境，且非小程序
    return /MicroMessenger/.test(getUa()) && !(/miniProgram/i.test(getUa()) && /micromessenger/i.test(getUa()))
  },
  isMZMall: () => {
    return /MZMall/.test(getUa())
  },
  isMZMallStandard: () => {
    return /MZMall\//.test(getUa())
  },
  isWeb: () => {
    return app.value === VALUE.WEB
  },
  value: () => {
    return app.isMZMall() ? VALUE.MZMall : ( app.isWechat() ? VALUE.WECHAT : VALUE.WEB)
  },
  isMZFilm: () => {
    return /Maizuo/.test(getUa())
  },
  isMZFilmV5: () => {
    return /Maizuo/.test(getUa()) && version.compare.gte(version.get(), '5.0.0')
  },
  isWechatMiniProgram: (callback) => {
    if(!app.isWechat()) {
      return callback(false)
    }
    //ios的ua中无miniProgram，但都有MicroMessenger（表示是微信浏览器;
    //从微信7.0.0开始，可以通过判断userAgent中包含miniProgram字样来判断小程序web-view环境
    wx.miniProgram.getEnv((res)=>{
      console.log('getenv', res, res.miniprogram)
      callback(res.miniprogram)
    })
  },
  isMPSdtj: () => { // 判断是否是在苏打体检小程序里
    if(cookie(CONSTANT.COOKIE_CO) !== CONSTANT.COOKIE_CO_IS_MP_SDTJ) {
      // callback(false)
      return false
    }
    return /miniProgram/i.test(getUa()) && /micromessenger/i.test(getUa())
    // wx.miniProgram.getEnv((res)=>{
    //   console.log('getenv', res, res.miniprogram)
    //   callback(res.miniprogram)
    // })

  }
}

export const os = {
  isAndroid: () => {
    return /Android/i.test(getUa())
  },
  isIOS: () => {
    return /iPhone|iPad|iPad/i.test(getUa())
  },
  isOther: () => {
    return !os.isAndroid() && !os.isIOS()
  },
  value: () => {
    return os.isIOS() ? VALUE.IOS :
      os.isAndroid() ? VALUE.ANDROID:
      VALUE.OTHER
  }
}
